import { useEffect } from "react";
import { useHistory } from "react-router-dom";
import { useSelector } from "react-redux";
import { AUTH_ROOT_ROUTE, LOGIN_ROUTE } from "routes/auth/authPaths";

const useAuthentication = () => {
  const history = useHistory();
  const { isAuthenticated } = useSelector(({ auth }) => auth);

  useEffect(() => {
    if (!isAuthenticated) {
      history.push(AUTH_ROOT_ROUTE + LOGIN_ROUTE, {
        from: history.location.pathname,
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isAuthenticated]);
};

export default useAuthentication;
